import { getAuthAxiosInstance } from '../axios-config';
import IToken from '../../interfaces/IToken';
import IIdentityToken from '../../interfaces/IIdentityToken';
import i18next from '../../../lib/i18n';
import IApiResponse from '../../interfaces/IApiResponse';

export const getToken = async (
    codeValue: string,
    redirectUriValue: string,
    user: number,
): Promise<IApiResponse<IToken>> => {
    try {
        const Api = await getAuthAxiosInstance();
        const response = await Api.post('/v1/oauth/token', {
            code: codeValue,
            redirectUri: redirectUriValue,
            userType: user,
        });
        if (response.data) {
            populateStorage(response.data);
            return { response: response.data };
        }
        return { error: new Error(i18next.t('ErroObterAccessToken')) };
    } catch (error) {
        return { error: new Error((error as { message: string }).message) };
    }
};

export const getTokenByRefreshToken = async (
    refreshTokenValue: string,
    user: number,
): Promise<IApiResponse<IToken>> => {
    try {
        const Api = await getAuthAxiosInstance();
        const response = await Api.post('/v1/oauth/refreshToken', {
            refreshToken: refreshTokenValue,
            userType: user,
        });
        if (response.data) {
            populateStorage(response.data);
            return { response: response.data };
        }
        return { error: new Error(i18next.t('ErroObterNovoAccessToken')) };
    } catch (error) {
        return { error: new Error((error as { message: string }).message) };
    }
};

export const getIdentityToken = async (
    country: string | null = null,
): Promise<IApiResponse<IIdentityToken>> => {
    try {
        const Api = await getAuthAxiosInstance();
        const identityTokenResponse = await Api.get(
            `v1/oauth/identity?country=${country}`,
        );

        if (identityTokenResponse.data) {
            populateStorageIdentityToken(identityTokenResponse.data);
            return { response: identityTokenResponse.data };
        }

        return { error: new Error(i18next.t('ErroObterIdentityToken')) };
    } catch (error) {
        return { error: new Error((error as { message: string }).message) };
    }
};

const populateStorage = (data: IToken) => {
    sessionStorage.setItem('AccessToken', data.accessToken);
    sessionStorage.setItem('RefreshToken', data.refreshToken);
    sessionStorage.setItem('ExpiresIn', data.expiresIn.toString());
    sessionStorage.setItem(
        'RefreshExpiresIn',
        data.refreshExpiresIn.toString(),
    );
};

const populateStorageIdentityToken = (data: IIdentityToken) => {
    sessionStorage.setItem('IdentityToken', data.identityToken);
    sessionStorage.setItem(
        'ExpiresInIdentityToken',
        (data.expiresIn || '').toString(),
    );
};

export const deactivateUser = async (
    userId: string,
): Promise<IApiResponse<boolean>> => {
    try {
        const Api = await getAuthAxiosInstance();

        await Api.post(`v1/users/${userId}:deactivate`);

        return { response: true };
    } catch {
        return { error: new Error(i18next.t('DeactivateUserError')) };
    }
};
